import { reverse } from "ramda";

export const toDataTuples = (el: any[], i: number): any[] => [i, el[0], el[1]];

export const sortDataTuples1 = (a: any[], b: any[]): number =>
  Number(a[1]) - Number(b[1]);

export const sortTuples = (tuples: any[][]) =>
  reverse(tuples.slice().sort(sortDataTuples1));
